import React from 'react';

const MechanicalServiceSection = () => {
  return (
    <>
      <style jsx>{`
        .mechanical-service-section {
          background: white;
          position: relative;
          overflow: hidden;
        }

        .text-content-4 {
          background: #f8f9fa;
          padding: 60px 40px;
          position: relative;
          z-index: 2;
        }

        .text-container-4 {
          max-width: 1400px;
          margin: 0 auto;
        }

        .service-header-4 {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 40px;
          animation: fadeInLeft 0.8s ease-out;
        }

        .tools-icon {
          font-size: 3rem;
          color: #666;
          animation: toolsRotate 4s ease-in-out infinite;
        }

        @keyframes toolsRotate {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-10deg); }
          50% { transform: rotate(5deg); }
          75% { transform: rotate(-5deg); }
        }

        .service-title {
          font-size: 2.8rem;
          font-weight: bold;
          color: #2196F3;
          margin: 0;
          font-family: 'Arial', sans-serif;
          text-shadow: 2px 2px 4px rgba(33, 150, 243, 0.1);
        }

        .service-description {
          font-size: 1.3rem;
          color: #666;
          line-height: 1.8;
          margin: 0;
          font-family: 'Arial', sans-serif;
          animation: fadeInUp 0.8s ease-out 0.3s both;
        }

        .workshop-image-section {
          position: relative;
          height: 500px;
          background: url('/images/garage.png') center/cover no-repeat;
          overflow: hidden;
          animation: slideInFromBottom 1s ease-out 0.6s both;
        }

        .workshop-image-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            180deg, 
            rgba(0,0,0,0) 0%, 
            rgba(0,0,0,0.1) 50%, 
            rgba(0,0,0,0.3) 100%
          );
          z-index: 1;
        }

        .workshop-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(
            transparent 0%, 
            rgba(0,0,0,0.3) 50%, 
            rgba(0,0,0,0.6) 100%
          );
          height: 200px;
          z-index: 2;
        }

        .floating-cars {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          pointer-events: none;
        }

        .car-element {
          position: absolute;
          font-size: 3rem;
          opacity: 0.8;
          animation: carFloat 6s ease-in-out infinite;
        }

        .car-element:nth-child(1) {
          top: 60%;
          left: 15%;
          animation-delay: 0s;
        }

        .car-element:nth-child(2) {
          top: 65%;
          left: 45%;
          animation-delay: 2s;
        }

        .car-element:nth-child(3) {
          top: 70%;
          right: 25%;
          animation-delay: 4s;
        }

        .car-element:nth-child(4) {
          top: 75%;
          right: 8%;
          animation-delay: 1s;
        }

        @keyframes carFloat {
          0%, 100% { 
            transform: translateY(0px) scale(1); 
            opacity: 0.8; 
          }
          50% { 
            transform: translateY(-10px) scale(1.05); 
            opacity: 1; 
          }
        }

        .workshop-workers {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 4;
          pointer-events: none;
        }

        .worker-element {
          position: absolute;
          font-size: 2rem;
          animation: workerMove 8s ease-in-out infinite;
        }

        .worker-element:nth-child(1) {
          top: 70%;
          left: 10%;
          animation-delay: 0s;
        }

        .worker-element:nth-child(2) {
          top: 75%;
          left: 35%;
          animation-delay: 3s;
        }

        .worker-element:nth-child(3) {
          top: 65%;
          right: 35%;
          animation-delay: 6s;
        }

        @keyframes workerMove {
          0%, 100% { 
            transform: translateX(0px) scale(1); 
            opacity: 0.9; 
          }
          25% { 
            transform: translateX(10px) scale(1.1); 
            opacity: 1; 
          }
          50% { 
            transform: translateX(0px) scale(1); 
            opacity: 0.9; 
          }
          75% { 
            transform: translateX(-5px) scale(1.05); 
            opacity: 1; 
          }
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInFromBottom {
          from {
            opacity: 0;
            transform: translateY(100px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 1024px) {
          .service-title {
            font-size: 2.4rem;
          }

          .service-description {
            font-size: 1.2rem;
          }

          .workshop-image-section {
            height: 400px;
          }

          .car-element {
            font-size: 2.5rem;
          }

          .worker-element {
            font-size: 1.8rem;
          }
        }

        @media (max-width: 768px) {
          .text-content-4 {
            padding: 40px 20px;
          }

          .service-header-4 {
            flex-direction: column;
            text-align: center;
            gap: 15px;
            margin-bottom: 30px;
          }

          .service-title {
            font-size: 2rem;
          }

          .service-description {
            font-size: 1.1rem;
            text-align: center;
          }

          .workshop-image-section {
            height: 300px;
          }

          .car-element {
            font-size: 2rem;
          }

          .worker-element {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 480px) {
          .text-content-4 {
            padding: 30px 15px;
          }

          .service-title {
            font-size: 1.6rem;
          }

          .service-description {
            font-size: 1rem;
          }

          .workshop-image-section {
            height: 250px;
          }

          .car-element {
            font-size: 1.5rem;
          }

          .worker-element {
            font-size: 1.3rem;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="mechanical-service-section"
        role="region"
        aria-labelledby="mechanical-service-heading"
        itemScope
        itemType="https://schema.org/Service"
      >
        <div className="text-content-4">
          <div className="text-container-4">
            <header className="service-header-4">
              <div className="tools-icon" role="img" aria-label="Outils de mécanique">🛠️</div>
              <h2 
                id="mechanical-service-heading"
                className="service-title"
                itemProp="name"
              >
                Mécanique (atelier physique)
              </h2>
            </header>

            <p className="service-description" itemProp="description">
              Confiez-nous vos travaux de mécanique en atelier :<br />
              Changement de freins, batteries, amortisseurs, révisions périodiques ou diagnostics électroniques.<br />
              Nous assurons un service rapide, clair, avec des pièces de qualité et des délais maîtrisés.
            </p>
          </div>
        </div>

        <div 
          className="workshop-image-section"
          role="img"
          aria-label="Atelier de mécanique automobile Faucon Bleu"
          itemProp="image"
        >
          <div className="workshop-overlay" aria-hidden="true"></div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Mécanique automobile - Atelier physique",
              "description": "Service de mécanique automobile en atelier: freins, batteries, amortisseurs, révisions périodiques, diagnostics électroniques. Service rapide avec pièces de qualité.",
              "provider": {
                "@type": "AutoRepair",
                "name": "Faucon Bleu",
                "url": "https://fauconbleu.ma"
              },
              "areaServed": {
                "@type": "City",
                "name": "Casablanca",
                "addressCountry": "MA"
              },
              "serviceType": "Automotive Repair",
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Services de mécanique",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Changement de freins",
                      "description": "Réparation et remplacement du système de freinage"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Changement de batteries",
                      "description": "Remplacement de batterie automobile"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Changement d'amortisseurs",
                      "description": "Réparation et remplacement des amortisseurs"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Révisions périodiques",
                      "description": "Entretien préventif et révision complète du véhicule"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Diagnostics électroniques",
                      "description": "Diagnostic informatique et électronique automobile"
                    }
                  }
                ]
              }
            })
          }}
        />
      </section>
    </>
  );
};

export default MechanicalServiceSection;